<template>
  <el-dialog
    width="600px"
    title="选择制作唛头所用模板"
    :visible="isShow"
    custom-class="make-style"
    :before-close="handleMakeClose"
    destroy-on-close
  >
    <el-radio-group v-model="makeRadio">
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in makeList"
          :key="index"
          :span="12"
        >
          <el-radio :label="item.templateId">
            {{ item.markTemplateName }}
          </el-radio>
        </el-col>
      </el-row>
    </el-radio-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleMakeClose">取消</el-button>
      <el-button type="primary" @click="submitMake">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getEnableMarkTemplate
} from '@/API';
export default {
  data () {
    return {
      isShow: false,
      makeList: [],
      makeRadio: '',
      makePage: {
        pageSize: 7777,
        pageIndex: 1,
        total: 0
      }
    };
  },
  methods: {
    openDialog () {
      this.initData();
      this.isShow = true;
    },

    initData () {
      getEnableMarkTemplate({
        pageIndex: this.makePage.pageIndex,
        pageSize: this.makePage.pageSize
      }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.makeList = data.list;
          this.isShow = true;
        }
      });
    },

    submitMake () {
      this.$emit('submit-make', this.makeRadio);
    },

    handleMakeClose () {
      this.isShow = false;
      this.makeRadio = '';
      this.makeList = [];
      this.makePage.pageIndex = 1;
    }
  }
};
</script>
